import React from "react";
import styled from "styled-components";

type TextTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "a";

type TextType = "title" | "subtitle" | "normal";

type TextFontFamily = "Campuni" | "Mulish";

type FontSize = "small" | "medium" | "large";

type FontWeight = "bold" | "normal" | "italic" | "stroke" | "700";

interface TextProps {
  as?: TextTag;
  type?: TextType;
  size?: FontSize;
  font?: TextFontFamily;
  children: React.ReactNode;
  style?: React.CSSProperties;
  weight?: FontWeight;
  color?: string;
}

const StyledText = styled.div<TextProps>`
  font-family: ${({ font }) =>
    font === "Mulish" ? "Mulish, sans-serif" : "Campuni Test, sans-serif"};
  font-weight: ${({ weight }) => !!weight && `${weight}`};
  font-size: ${({ size }) => {
    switch (size) {
      case "small":
        return "14px";
      case "medium":
        return "16px";
      case "large":
        return "24px";
      default:
        return "inherit";
    }
  }};
  color: ${({ color, type }) => {
    if (color) {
      return color;
    }
    switch (type) {
      case "title":
        return "#28293D";
      case "normal":
        return "#555770";
      case "subtitle":
        return "#7B80FF";
      default:
        return "#555770";
    }
  }};
  ${({ type }) =>
    type === "title" &&
    `
    font-size: 2.5rem;
    font-weight: 700;
    font-family: Campuni Test, sans-serif;
  `}
  ${({ type }) =>
    type === "subtitle" &&
    `
    font-size: 2rem;
    font-weight: 700;
    font-family: Campuni, sans-serif;
  `}
`;

export const SEText: React.FC<TextProps> = (props) => {
  return (
    <StyledText {...props} as={props.as}>
      {props.children}
    </StyledText>
  );
};
